module.exports = __webpack_public_path__ + "assets/icon-handle-kit.31ccf604.svg";